<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    components: {},

    data() {
      return {}
    },
  }
</script>

<style lang="scss">
  @import './assets/all';

  #app {
    font-family: 'Roboto', '微軟正黑體', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f2f2f2;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
